/// <reference path="../Bases/BOMDialog.ts" />
namespace _Ext {

    @Serenity.Decorators.registerClass()
    export class BOMEditorDialog<TEntity> extends BOMDialog<TEntity, any> {

        protected get_ExtDialogOptions(): ExtDialogOptions { return q.DefaultEditorDialogOptions; }

        protected getFormKey() { return 'Common.CommonBOMForm' }
        protected form = new TabAurous.Common.CommonBOMForm(this.idPrefix);
        protected getIdProperty() { return "__id"; }

        public onSave: (options: Serenity.ServiceOptions<Serenity.SaveResponse>,
            callback: (response: Serenity.SaveResponse) => void) => void;

        public onDelete: (options: Serenity.ServiceOptions<Serenity.DeleteResponse>,
            callback: (response: Serenity.DeleteResponse) => void) => void;

        public destroy() {
            this.onSave = null;
            this.onDelete = null;
            super.destroy();
        }

        protected updateInterface() {
            super.updateInterface();
            this.saveAndCloseButton.find('.button-inner').text(this.isNew() ? (Q.tryGetText('Controls.AddButton') || 'Add') : (Q.tryGetText('Controls.ApplyButton') || 'Apply'));
            // apply changes button doesn't work properly with in-memory grids yet
            if (this.applyChangesButton) {
                this.applyChangesButton.hide();
            }

            if (this.parentEditor && this.parentEditor.isReadOnly == true) {
                this.saveAndCloseButton.addClass('disabled');
                this.deleteButton.addClass('disabled');
                this.applyChangesButton.addClass('disabled');
                // remove required asterisk (*)
                this.element.find('sup').hide();

            }
        }

        protected saveHandler(options: Serenity.ServiceOptions<Serenity.SaveResponse>,
            callback: (response: Serenity.SaveResponse) => void): void {
            this.onSave && this.onSave(options, callback);
        }

        protected deleteHandler(options: Serenity.ServiceOptions<Serenity.DeleteResponse>,
            callback: (response: Serenity.DeleteResponse) => void): void {
            this.onDelete && this.onDelete(options, callback);
        }

        parentEditor: BOMGridEditor<TEntity>;

        PartyId: number;
        RateListId: number;
        LaborListId: number;
        StoneMarkup: number;
        StoneDiscount: number;
        LaborMarkup: number;
        LaborDiscount: number;
        ExchangeRate: number;
        MarkUpPolicyId: number;
        TransDate: Date;
        BOMMaster: any;
        UseKaratWiseRate: boolean = false;
        IsConfigurable: boolean = false;

        protected validateBeforeSave() {

            if (this.form.ItemTypeId.value == 104) {
                TabAurous.OMS.CommonAttributesService.GetProductATB({
                    ProductTypeId: Q.parseInteger(this.form.ProductTypeId.value),
                    ItemTypeId: this.form.ItemTypeId.value,
                    CategoryId: Q.parseInteger(this.form.CategoryId.value),
                    SubCategoryId: Q.parseInteger(this.form.SubCategoryId.value),
                    MetalColorId: Q.parseInteger(this.form.MetalColorId.value),
                    KaratId: Q.parseInteger(this.form.KaratId.value)
                },
                    response => {
                        this.form.BOMAttributeId.value = response.AttributeId.toString(),
                            this.form.Attribute.value = response.AttributeCode
                    },
                    { async: false }
                );
            }

            if (this.form.ItemTypeId.value == 105) {
                TabAurous.OMS.CommonAttributesService.GetProductATB({
                    ProductTypeId: Q.parseInteger(this.form.ProductTypeId.value),
                    ItemTypeId: this.form.ItemTypeId.value,
                    CategoryId: Q.parseInteger(this.form.CategoryId.value),
                    SubCategoryId: Q.parseInteger(this.form.SubCategoryId.value),
                    ShapeId: Q.parseInteger(this.form.ShapeId.value),
                    QualityId: Q.parseInteger(this.form.QualityId.value),
                    StoneSizeId: Q.parseInteger(this.form.StoneSizeId.value),
                    SieveId: Q.parseInteger(this.form.SieveId.value),
                    GroupSieveId: Q.parseInteger(this.form.GroupSieveId.value),
                    StoneColorId: Q.parseInteger(this.form.StoneColorId.value),
                    StoneCutId: Q.parseInteger(this.form.StoneCutId.value),
                    StonePolishId: Q.parseInteger(this.form.StonePolishId.value),
                    StoneSymmetryId: Q.parseInteger(this.form.StoneSymmetryId.value),
                    StoneFluorescenceId: Q.parseInteger(this.form.StoneFluorescenceId.value),
                    StoneCuletId: Q.parseInteger(this.form.StoneCuletId.value),
                    StoneGirdleId: Q.parseInteger(this.form.StoneGirdleId.value),
                    StoneTable: this.form.StoneTable.value,
                    StoneDepth: this.form.StoneDepth.value
                },
                    response => {
                        this.form.BOMAttributeId.value = response.AttributeId.toString(),
                            this.form.Attribute.value = response.AttributeCode
                    },
                    { async: false }
                );


            }

            //this.form.RefTransBomId === undefined ? this.form.RefTransBomId = 0 : this.form.RefTransBomId;
            return true;
        }

        protected GetRate() {
            this.setMastervalues();
            var calcon = this.form.CalcOnId.value;
            this.RateListId = (this.parentEditor.parentDialog as any).RateListId;

            if (this.form.ItemTypeId.value == 105) {
                var rateatb: TabAurous.RateHelper.RateAttributes = {
                    ProductTypeId: parseInt(this.form.ProductTypeId.value),
                    CategoryId: parseInt(this.form.CategoryId.value),
                    SubCategoryId: parseInt(this.form.SubCategoryId.value),
                    ShapeId: parseInt(this.form.ShapeId.value),
                    SieveId: parseInt(this.form.SieveId.value),
                    GroupSieveId: parseInt(this.form.GroupSieveId.value),
                    StoneSizeId: parseInt(this.form.StoneSizeId.value),
                    StoneColorId: parseInt(this.form.StoneColorId.value),
                    QualityId: parseInt(this.form.QualityId.value),
                    RateListId: this.RateListId,
                    ProductId: parseInt(this.form.BOMProductId.value),
                    CostMethodId: parseInt(this.form.CostMethodId.value),
                    Weight: this.form.Weight.value
                }
                this.form.BomRate.value = TabAurous.RateHelper.GetStonePurchaseRatenoAtb(rateatb);



                // for Markup Calculation

                let stonemarkup = 0;
                if (this.MarkUpPolicyId > 0) {
                    let StoneMarkUpType = (TabAurous.GetConfigValue(1039));

                    TabAurous.OMS.MarkupChargesService.GetMarkUp({
                        ProductTypeId: Q.parseInteger(this.form.ProductTypeId.value),
                        ItemTypeId: this.form.ItemTypeId.value,
                        CategoryId: Q.parseInteger(this.form.CategoryId.value),
                        SubCategoryId: Q.parseInteger(this.form.SubCategoryId.value),
                        QualityId: Q.parseInteger(this.form.QualityId.value),
                        StoneColorId: Q.parseInteger(this.form.StoneColorId.value),
                        SieveId: Q.parseInteger(this.form.SieveId.value),
                        StoneSizeId: Q.parseInteger(this.form.StoneSizeId.value),
                        ShapeId: Q.parseInteger(this.form.ShapeId.value),
                        MarkUpPolicyId: this.MarkUpPolicyId,
                        StoneMarkUpType: parseInt(StoneMarkUpType),
                        MarkUpType: 1
                    },
                        response => {
                            if (response.Entity != null) {
                                if (response.Entity.MarkUpRateType == 1) {
                                    this.form.BomRate.value = response.Entity.MarkUp;
                                    stonemarkup = 1;
                                } else if (response.Entity.MarkUpRateType == 2) {
                                    stonemarkup = response.Entity.MarkUp;
                                    this.form.Markup.value = response.Entity.MarkUp;
                                }
                            }
                            else {
                                this.form.Markup.value = 0;
                            }
                        }, { async: false })
                }



                this.form.BomRate.value = this.form.BomRate.value / this.ExchangeRate;

                if (calcon == "4" || calcon == "5")
                    this.form.BomAmount.value = this.form.BomRate.value * this.form.Weight.value;
                if (calcon == "3")
                    this.form.BomAmount.value = this.form.BomRate.value * this.form.Pieces.value;

                this.form.BomAmount.value = stonemarkup > 1 ? this.form.BomAmount.value * stonemarkup : this.form.BomAmount.value;
            }
            else if (this.form.ItemTypeId.value == 104) {
                this.form.BomRate.value = TabAurous.RateHelper.GetMetalRate(parseInt(this.form.ProductTypeId.value), parseInt(this.form.KaratId.value), false, new Date());
                let UseKaratRate = q.ToBool(TabAurous.GetConfigValue(1021));
                //for Markup Calculation
                let metalmarkup = 0;
                if (this.MarkUpPolicyId > 0) {
                    let MetalMarkUpType = (TabAurous.GetConfigValue(1040));
                    TabAurous.OMS.MarkupChargesService.GetMarkUp({
                        ProductTypeId: Q.parseInteger(this.form.ProductTypeId.value),
                        ItemTypeId: this.form.ItemTypeId.value,
                        CategoryId: Q.parseInteger(this.form.CategoryId.value),
                        SubCategoryId: Q.parseInteger(this.form.SubCategoryId.value),
                        KaratId: Q.parseInteger(this.form.KaratId.value),
                        MetalColorId: Q.parseInteger(this.form.MetalColorId.value),
                        MarkUpPolicyId: this.MarkUpPolicyId,
                        MetalMarkUpType: parseInt(MetalMarkUpType),
                        MarkUpType: 1

                    },
                        response => {
                            if (response.Entity != null) {
                                if (response.Entity.MarkUpRateType == 1) {
                                    this.form.BomRate.value = response.Entity.MarkUp;
                                    metalmarkup = 1;
                                } else if (response.Entity.MarkUpRateType == 2) {
                                    metalmarkup = response.Entity.MarkUp;
                                    this.form.Markup.value = response.Entity.MarkUp;
                                }
                            }
                            else {
                                this.form.Markup.value = 0;
                            }

                        }, { async: false })
                }

                this.form.BomRate.value = this.form.BomRate.value / this.ExchangeRate;
                if (calcon == "4" || calcon == "5")
                    this.form.BomAmount.value = UseKaratRate == true ? this.form.BomRate.value * this.form.Weight.value : this.form.BomRate.value * this.form.Weight.value * this.form.Purity.value

                if (calcon == "3")
                    this.form.BomAmount.value = this.form.BomRate.value * this.form.Pieces.value;

                this.form.BomAmount.value = metalmarkup > 1 ? this.form.BomAmount.value * metalmarkup : this.form.BomAmount.value;
            }

            this.form.CCBomAmount.value = this.form.BomAmount.value * this.ExchangeRate;
        }

        setMastervalues() {
            this.BOMMaster = (this.parentEditor.parentDialog as any);
            this.RateListId = this.BOMMaster.RateListId;
            this.LaborListId = this.BOMMaster.LaborListId;
            this.StoneMarkup = this.BOMMaster.StoneMarkup;
            this.StoneDiscount = this.BOMMaster.StoneDisount;
            this.ExchangeRate = this.BOMMaster.ExchangeRate;
            this.TransDate = this.BOMMaster.TransDate;
            this.PartyId = this.BOMMaster.PartyId;
            this.MarkUpPolicyId = this.BOMMaster.MarkUpPolicyId;
        }
    }
}